import { storeStructure } from '../store/reducers';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  title: 'Setup values',
  attributeName: 'appDynamicProviderForm',
  fields: [
    {
      attributeName: 'purchaseDynamicProcessURL',
      helpText: 'The URL to start a purchase process by the end user.',
      type: FormInputTypes.TEXT,
      label: 'Purchase URL',
    },
    {
      attributeName: 'name',
      helpText: 'Provider Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Name',
      placeholder: 'name...',
    },
    {
      attributeName: 'providerImage',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Logo',
      helpText: 'Logo to identify the provider in the app.',
      placeholder: 'Poster URL...',
      fileType:['image/*']
    },
    {
      attributeName: 'uses',
      helpText: 'Num of uses per token',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Uses',
      placeholder: 'uses...',
      default: "1"
    },
    {
      attributeName: 'paymentServiceURL',
      helpText: 'Payment service url linked to the provider',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'URL',
      placeholder: 'url...',
    },
    {
      attributeName: 'trackingIdName',
      helpText: 'The tracking id name inside the payment service',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Tracking ID rename',
      placeholder: 'tracking id rename...',
      default: 'trackingId'
    },
    {
      attributeName: 'operationIdName',
      helpText: 'Operation ID name id inside the payment service',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Operation ID rename',
      placeholder: 'operation id rename...',
      default: 'operationId'
    },
    {
      attributeName: 'ipsAllowed',
      helpText: 'IPs of the payment service allowed to XMS conection',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'IPs allowed',
      multiple:true,
      placeholder: 'Press enter to add an IP...',
    },
  ],
};
